namespace $ {

	export type $shm_markdown_flow_token = {
		name: string
		found: string
		chunks: string[]
	}

	export function $shm_markdown_flow_no_indent_code< Token extends $shm_markdown_flow_token >( token: Token ): Token {
		if( token.name !== 'code-indent' ) return token
		return { ... token, name: 'block' }
	}

}
